import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2252">
      <div className="dark" data-id="element-2253">
        <Hero data-id="element-2254" />
      </div>
      <WhyUs data-id="element-2255" />
      <ByTheNumbers data-id="element-2256" />
      <Services data-id="element-2257" />
      <HowItWorks data-id="element-2258" />
      <FAQ data-id="element-2259" />
      <Reviews data-id="element-2260" />
      <CtaBanner data-id="element-2261" />
    </main>;
}